import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import styles from './table-header.module.scss'

export type TableHeaderElement = HTMLTableSectionElement

export type TableHeaderProps = HTMLAttributes<TableHeaderElement>

const TableHeader = forwardRef<TableHeaderElement, TableHeaderProps>(function TableHeader(
  props,
  ref
) {
  const { className, ...rest } = props
  const classes = classNames(styles.root, className)
  return <thead {...rest} className={classes} ref={ref} />
})

export default TableHeader
